import type { Scene } from '@babylonjs/core/scene';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { CreatePlane } from '@babylonjs/core/Meshes/Builders/planeBuilder';
import { CreateDisc } from '@babylonjs/core/Meshes/Builders/discBuilder';
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import { Color3 } from '@babylonjs/core/Maths/math.color';

/** Decorative ferryman: an oar cycle, gentle hull bob and wake on the Acheron. */
export class CharonView {
  readonly mesh:Mesh;
  private readonly texture:Texture;
  private readonly ripples:Mesh[]=[];
  private readonly home:{x:number;y:number;z:number};
  private time=0;
  private frames=1;
  constructor(scene:Scene,x:number,z:number){
    this.mesh=CreatePlane('charon-ferry',{width:6.3,height:4.2},scene);
    this.mesh.billboardMode=Mesh.BILLBOARDMODE_Y;this.mesh.isPickable=false;
    this.home={x,y:-.25,z:z+1};
    this.texture=new Texture('/proto2d/inferno/charon-boat.png',scene,true,true,Texture.NEAREST_SAMPLINGMODE);
    this.texture.hasAlpha=true;this.texture.wrapU=this.texture.wrapV=Texture.CLAMP_ADDRESSMODE;
    const material=new StandardMaterial('charon-ferry',scene);
    material.diffuseTexture=this.texture;material.useAlphaFromDiffuseTexture=true;
    material.disableLighting=true;material.emissiveColor=Color3.FromHexString('#d5c8b9');material.backFaceCulling=false;
    this.mesh.material=material;
    void fetch('/proto2d/inferno/charon-boat.json').then(r=>r.ok?r.json():null).then(data=>{
      if(!data?.frames)return;
      const animated=new Texture('/proto2d/inferno/charon-row.png',scene,true,true,Texture.NEAREST_SAMPLINGMODE,()=>{
        this.frames=data.frames;animated.hasAlpha=true;animated.wrapU=animated.wrapV=Texture.CLAMP_ADDRESSMODE;
        animated.uScale=1/this.frames;material.diffuseTexture=animated;this.animated=animated;
      });
    }).catch(()=>{});
    for(let i=0;i<3;i++){
      const ring=CreateDisc('ferry-wake',{radius:2,tessellation:32},scene);
      ring.rotation.x=Math.PI/2;ring.position.set(x,-2.37,z+1);ring.isPickable=false;
      const water=new StandardMaterial('wake',scene);water.disableLighting=true;
      water.emissiveColor=Color3.FromHexString('#b87045');water.alpha=.1;ring.material=water;
      this.ripples.push(ring);
    }
  }
  private animated:Texture|null=null;
  update(dt:number){
    this.time+=dt;
    this.mesh.position.set(this.home.x+Math.sin(this.time*.25)*.12,this.home.y+Math.sin(this.time*1.6)*.07,this.home.z);
    this.mesh.rotation.z=Math.sin(this.time*.8)*.015;
    if(this.animated)this.animated.uOffset=Math.floor(this.time*5)%this.frames/this.frames;
    this.ripples.forEach((r,i)=>{
      const phase=(this.time*.3+i/3)%1;r.scaling.set(1+phase*1.2,.5+phase*.5,1);
      (r.material as StandardMaterial).alpha=(1-phase)*.08;
    });
  }
}
